//已经定义了 不能引入 会报错的～
if (!window._babelPolyfill) {
    require("babel-polyfill");
}
import Util from "./util/index";
import { callAbtestApp } from "./call-app";
import BindEvent from "./bindEvent";
import MockData from "./mock";
import { isQuickAPP, isAlipay, isWeibo } from "./util/useragent";

//请求jdata 获取一下数据
const Url = "alipays://platformapi/startapp?appId=2018032302435038&page=pages/home/home&query=";
/**
 * @param {*} config
 * config.success : 对话框确认
 * config.close : 对话框关闭
 * config.goWebLogin:取消去网页登录
 * config.fail：未命中切流那部分流量
 * config.isDetail = true detail手工唤起需要打另一个数据点
 * config.
 */
//获取分流的jdata


const getAbtestChannel = "https://dcms.1688.com/open/query.json?app=DCMS&dataId=236&resourceId=603861";
function _init(config = {}) {

    //特殊逻辑的业务直接不执行
    let tinyapp = Util.getUrlParam("tinyapp");
    if (isQuickAPP || tinyapp === "close" || isWeibo) {
        config.fail && config.fail();
        return;
    }
    //20180807 pd需求 唤起小程序流量20%流量不唤起
    // let isEndNum = Util.getEndChannel();
    // isEndNum 范围是0-9
    // if (2 > isEndNum) {
    //     //命中切流 20%
    //     if (config.hasOwnProperty("notCallAPP") && typeof config.notCallAPP == "function") {
    //         config.notCallAPP();
    //     }
    //     return;
    // }
    let arrive_small_app_time = Util.getUrlParam("d_t");
    let dmtpid = Util.getUrlParam("dmtpid");
    //判断如果是支付宝小程序里，并且带有参数的
    if (isAlipay && arrive_small_app_time && dmtpid) {
        //打点
        if (window['goldlog'] && goldlog.record) {
            goldlog.record('/1688_qyzb_new.call-app-time.call-success-app-time', 'CLK', 'dpid=' + dmtpid + "&d_t_small_app=" + arrive_small_app_time + "&d_t_app_h5=" + new Date().getTime(), 'GET');
        }
    }
    let jdata_url;
    let onlineAbtestChannel;
    Util.jsonp({
        url: getAbtestChannel,
        callback: "callback",
        data: {},
        success: function (res) {
            let channelData;
            try {
                channelData = JSON.parse(res.content.data[0].versionContent);
            } catch (e) {
                console.log("本地走mock数据");
                channelData = { onlineAbtest: 0.5 };
            }
            //是否命中流量
            let _end = Util.getEndChannel();
            let onlineAbtest = parseFloat(channelData.onlineAbtest) * 10;
            if (onlineAbtest > _end) {
                //命中切流
                onlineAbtestChannel = true;
                jdata_url = "https://dcms.1688.com/open/query.json?app=DCMS&dataId=236&resourceId=603924";
            } else {
                onlineAbtestChannel = false;
                jdata_url = "https://dcms.1688.com/open/query.json?app=DCMS&dataId=236&resourceId=569280"
            }
            Util.jsonp({
                url: jdata_url,
                callback: "callback",
                data: {},
                success: function (result) {
                    let abtestFlag;
                    try {
                        abtestFlag = JSON.parse(result.content.data[0].versionContent);
                    } catch (e) {
                        console.log("本地走mock数据");
                        //走下mock 数据
                        abtestFlag = MockData.content.data[0].versionContent;
                    }
                    //判断是不是直接流量
                    let _end = Util.getEndChannel();
                    var _preObj = Util.getUrlParms();
                    _preObj.dmtpid = window.dmtrack_pageid || "";
                    let pathName = window.location.pathname;
                    delete _preObj.refer;
                    let refer = document.referrer || "";
                    let refStr = "";
                    //判断是不是1688refer
                    if (!/https?:\/\/([\-_.\w]+)?\.1688\.com.*$/.test(refer)) {
                        refStr = "";
                    } else {
                        refStr = "refer=" + encodeURIComponent(refer);
                    }
                    let _url;
                    let _href = Util.getLocationOrigin() + pathName + "?";

                    if (Util.isOriginSEM()) {
                        //判断如果是sem直接渠道流量的
                        let cosite = Util.getUrlParam('cosite') || "";
                        let reg = new RegExp(abtestFlag.cosite || "");
                        _preObj.trace = "tinyapp_sem_moblie";
                        _url = _href + Util.getJsonToParamAlipay(_preObj) + "&" + refStr;
                        if (false) {
                            //sem广告流量过来 sogoujj
                            let start = abtestFlag.sogoujj * 10;
                            callAbtestApp({
                                start,
                                end: _end,
                                config,
                                abtestFlag,
                                _url,
                                refer: refStr,
                                onlineAbtestChannel
                            })
                        } else if (Util.isFromSEM()) {
                            //判断detail referer 是不是从sogoujj 跟 shenmajj 过来的
                            let flag = Util.isReferFromCosite();
                            if (flag) {
                                //100% 唤起
                                callAbtestApp({
                                    start: 10,
                                    end: _end,
                                    config,
                                    abtestFlag,
                                    _url,
                                    refer: refStr,
                                    onlineAbtestChannel
                                })
                            } else {
                                //detai判断是sem渠道跳过来的
                                let start = abtestFlag.SEM * 10;
                                callAbtestApp({
                                    start,
                                    end: _end,
                                    config,
                                    abtestFlag,
                                    _url,
                                    refer: refStr,
                                    onlineAbtestChannel
                                })
                            }
                        }
                    }
                    else if (Util.isFromCPS()) {
                        //判断是否CPS渠道来源
                        _preObj.trace = "tinyapp_cps_moblie";
                        _url = _href + Util.getJsonToParamAlipay(_preObj) + "&" + refStr;
                        let start = abtestFlag.CPS * 10;
                        callAbtestApp({
                            start,
                            end: _end,
                            config,
                            abtestFlag,
                            _url,
                            refer: refStr,
                            onlineAbtestChannel
                        })
                    } else if (Util.isFromSEO()) {
                        //判断是否SEO渠道来源
                        _preObj.trace = "tinyapp_seo";
                        _url = _href + Util.getJsonToParamAlipay(_preObj) + "&" + refStr;
                        let start = abtestFlag.SEO * 10;
                        callAbtestApp({
                            start,
                            end: _end,
                            config,
                            abtestFlag,
                            _url,
                            refer: refStr,
                            onlineAbtestChannel
                        })
                    } else {
                        //按网站直接流量来算
                        _preObj.trace = "tinyapp_orign";
                        _url = _href + Util.getJsonToParamAlipay(_preObj) + "&" + refStr;
                        let start = abtestFlag.SITE * 10;
                        callAbtestApp({
                            start,
                            end: _end,
                            config,
                            abtestFlag,
                            _url,
                            refer: refStr,
                            onlineAbtestChannel
                        })
                    }
                    BindEvent && BindEvent(abtestFlag, config, _url, {});
                }
            });
        }
    });
}



//test
// let start, i = 0, pre=new Date().getTime()
// function step(timestamp) {
//     var progress = timestamp - pre;
//     pre =  timestamp;
//     i++;
//     if (progress >= 2000) {
//         //唤起成功
//         console.log("唤起成功。离开浏览器")
//     }else{
//         //唤起不成功
//         console.log("唤起不成功");
//     }
//     window.requestAnimationFrame(step);
// }
// window.requestAnimationFrame(step);

Util.myDOMReady(function () {
    _init();
})

export function init(config) {
    _init && _init({
        ...config,
        manual: true
    })
}



// WEBPACK FOOTER //
// ./src/index.js